export default "__VITE_ASSET__CbwiUl4x__"